import Marques from "../components/Marques";

const Restauration = () => {
  return <Marques displayLines={false} />;
};

export default Restauration;
